import api from './api'
import type { ConversationAISetting } from '@/types'
import type { ApiResponse, UpdateConversationAISettingsRequest } from '@/types/api'

const ConversationAIService = {
  async get(conversationId: string): Promise<ConversationAISetting> {
    const response = await api.get<ApiResponse<ConversationAISetting>>(
      `/api/v1/conversations/${conversationId}/ai-settings`,
    )
    return response.data.data
  },

  async update(
    conversationId: string,
    data: UpdateConversationAISettingsRequest,
  ): Promise<ConversationAISetting> {
    const response = await api.put<ApiResponse<ConversationAISetting>>(
      `/api/v1/conversations/${conversationId}/ai-settings`,
      data,
    )
    return response.data.data
  },
}

export default ConversationAIService
